import React from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { Calendar, Crown, Star } from 'lucide-react';

const SubscriptionStatus = () => {
  const { isTrialActive, isSubscriptionActive, getDaysLeftInTrial, isSpecialAccount } = useSubscription();

  if (!isTrialActive() && !isSubscriptionActive()) {
    return null;
  }

  const daysLeft = getDaysLeftInTrial();

  return (
    <div className="flex items-center gap-2">
      {isSpecialAccount() ? (
        <div className="flex items-center gap-1 bg-purple-900/20 border border-purple-500/30 text-purple-400 px-2 py-1 rounded-full text-xs">
          <Star className="w-3 h-3" />
          <span>Special</span>
        </div>
      ) : isTrialActive() ? (
        <div className="flex items-center gap-1 bg-blue-900/20 border border-blue-500/30 text-blue-400 px-2 py-1 rounded-full text-xs">
          <Calendar className="w-3 h-3" />
          <span>{daysLeft}d trial</span>
        </div>
      ) : isSubscriptionActive() ? (
        <div className="flex items-center gap-1 bg-green-900/20 border border-green-500/30 text-green-400 px-2 py-1 rounded-full text-xs">
          <Crown className="w-3 h-3" />
          <span>Pro</span>
        </div>
      ) : null}
    </div>
  );
};

export default SubscriptionStatus; 